// The four entity types the merges API supports, matching
// Admin::Api::MergesController#supported_types. `value` is the exact STI class
// name the API keys on; `label` is what the admin sees.
export const MERGE_TYPES = [
  { value: "Id::MediaOutlet", label: "Media Outlet" },
  { value: "Id::PromoEntity::Company", label: "Company" },
  { value: "Id::PromoEntity::Product", label: "Product" },
  { value: "Id::PromoEntity::Expert", label: "Expert" },
];

export const typeLabel = (value) => MERGE_TYPES.find((t) => t.value === value)?.label || value;

// The confirmation word the operator must type before a merge executes.
export const CONFIRM_WORD = "MERGE";

// Only Experts can be self-representing; a self-expert is a valid merge
// destination but never a valid source (Admin::Merging::Expert refuses it).
export const SELF_EXPERT_SOURCE_TOOLTIP =
  "A self-representing expert cannot be a merge source — merging it away would delete the entity its " +
  "user's profile depends on. It may be used as a destination instead.";

// Turn a preview key like "representations_count" into "Representations count".
export const humanizeKey = (key) => {
  const spaced = key.replace(/_/g, " ").trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

// Preview keys that are structural / rendered specially and should not appear in
// the generic field list.
export const PREVIEW_META_KEYS = ["id", "self_expert", "links"];
